import { MouseEventHandler, ReactNode } from "react"
import { IconButton } from "@mui/material"
import { Refresh, Warning } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import type { IntradayToolbarTimesProp } from "../helpers/intraday-toolbar-times"
import IntradayTimesInfo from "./intraday-times-info"

export default function IntradayDataInfo({
  isIntradayEnabled,
  isEndDateToday,
  toolbarTimes,
  showWarning,
  showRefreshButton,
  onRefresh,
  refreshButtonTooltip,
  isLoadingDates,
  useLatestDate,
}: IntradayDataInfoProps) {
  if (!isIntradayEnabled || isLoadingDates) return null

  if (showWarning) {
    return (
      <OPTooltip title={<span>
        No intraday data
        {useLatestDate && <>
          <br />
          Using end of previous day
        </>}
      </span>}
      >
        <Warning className="intraday-warning" />
      </OPTooltip>
    )
  }

  const timeStamp: ReactNode = isEndDateToday && toolbarTimes
    ? <IntradayTimesInfo data={toolbarTimes.data} qualifiers={toolbarTimes.qualifiers} />
    : null

  if (showRefreshButton) {
    return (
      <div className="intraday-data-info">
        {timeStamp}
        <OPTooltip title={refreshButtonTooltip}>
          <IconButton
            color="primary"
            className="intraday-reload-button"
            size="large"
            onClick={onRefresh}
          >
            <Refresh />
          </IconButton>
        </OPTooltip>
      </div>
    )
  }

  return timeStamp
}

interface IntradayDataInfoProps {
  isIntradayEnabled: boolean
  isEndDateToday: boolean
  toolbarTimes: IntradayToolbarTimesProp | null
  showWarning: boolean
  showRefreshButton: boolean
  onRefresh: MouseEventHandler<HTMLButtonElement>
  refreshButtonTooltip: string
  isLoadingDates: boolean
  useLatestDate: boolean
}
